export enum MATCH_OUTCOME {
  MATCH = 'MATCH',
  MATCHED_EXPECTED = 'MATCHED_EXPECTED',
  MATCHED_UNEXPECTED_STOCKITEM = 'MATCHED_UNEXPECTED_STOCKITEM',
  MATCHED_UNEXPECTED_FACET = 'MATCHED_UNEXPECTED_FACET',
  NO_MATCH = 'NO_MATCH',
}

export const matchOutcomeDisplayMap: Record<MATCH_OUTCOME, string> = {
  [MATCH_OUTCOME.MATCH]: 'Matched',
  [MATCH_OUTCOME.MATCHED_EXPECTED]: 'Matched expected',
  [MATCH_OUTCOME.MATCHED_UNEXPECTED_STOCKITEM]: 'Matched unexpected stock item',
  [MATCH_OUTCOME.MATCHED_UNEXPECTED_FACET]: 'Matched unexpected facet',
  [MATCH_OUTCOME.NO_MATCH]: 'No match',
};

export function isValidMatchOutcome(value: string): boolean {
  return Object.values(MATCH_OUTCOME).includes(value as MATCH_OUTCOME);
}
